import { render, staticRenderFns } from "./FormGeneralInvoice.vue?vue&type=template&id=e780efda&"
import script from "./FormGeneralInvoice.vue?vue&type=script&lang=js&"
export * from "./FormGeneralInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports